import type { Route } from './router'

export const navigation: { label: string; href: Route; summary: string }[] = [
  { label: 'Features', href: '/features', summary: 'Search, OCR, semantic retrieval and governance' },
  { label: 'Infrastructure', href: '/infrastructure', summary: 'Applications, services and trust boundaries' },
  { label: 'Security', href: '/security', summary: 'Identity, endpoint trust and authorization' },
]

export const product = {
  name: 'Libris',
  tagline: 'Local-first document intelligence for Windows offices.',
  platform: 'Windows 10 22H2 · Windows 11 · x64',
  languages: 'English · Ελληνικά',
  year: 2026,
}
